<template>
  <div class="form-controls field-row">
    <p class="generic-form-feedback fc-darkred">
      <span v-show="showError">
        {{ $t(feedbackLabel) }}
      </span>
    </p>

    <div class="button-wrapper">
      <!-- Any trick shot from the product team may go in here -->
      <slot :go-back="goBack"
            :go-next="goNext"
            :retry="retry"
      >
        <sword-button-wuk v-if="actions.includes('back')"
                          text="onboarding_back"
                          theme="secondary"
                          size="large"
                          data-testid="button_formControlsBack"
                          :loading="loading"
                          @click.native="goBack"
        >
        </sword-button-wuk>
        <sword-button-wuk v-if="actions.includes('next')"
                          :text="continueLabel"
                          theme="primary"
                          :type="nextButtonType || 'submit'"
                          size="large"
                          data-testid="button_formControlsNext"
                          :loading="loading"
                          @click.native="goNext"
        >
        </sword-button-wuk>
        <sword-button-wuk v-if="actions.includes('retry')"
                          text="onboarding2_button_try_again"
                          theme="primary"
                          size="large"
                          data-testid="button_formControlsRetry"
                          :loading="loading"
                          @click.native="retry"
        >
        </sword-button-wuk>
      </slot>
    </div>
  </div>
</template>

<script>
import { tools } from '@sword-health/ui-core';

import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';

export default {
  name: 'FormControls',
  components: { SwordButtonWuk },
  props: {
    actions: {
      type: Array,
      required: true,
      validator(actions) {
        if (!actions.length) {
          return false;
        }

        // only possible actions are next, back and retry
        return actions.every(action => ['next', 'back', 'retry'].includes(action));
      },
    },
    continueLabel: {
      type: String,
      default: 'onboarding2_button_next',
    },
    showError: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    feedbackLabel: {
      type: String,
      default: 'onboarding_review_fields_label',
    },
    nextButtonType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      goNext: null,
      goBack: null,
      retry: null,
    };
  },
  created() {
    this.goNext = tools.debounce(this.sendNextEvent, 250, true);
    this.goBack = tools.debounce(this.sendBackEvent, 250, true);
    this.retry = tools.debounce(this.sendRetryEvent, 250, true);
  },
  methods: {
    sendNextEvent() {
      this.$emit('next');
    },
    sendBackEvent() {
      this.$emit('back');
    },
    sendRetryEvent() {
      this.$emit('retry');
    },
  },
};
</script>

<style lang="scss" scoped>
  .generic-form-feedback {
    @extend %t3;
    margin: 0 auto 0.625rem;
    min-height: 1.375rem;
    text-align: center;

    @media (max-width: break('small', 'l')) {
      margin: 1.25em auto;
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: center;

    button {
      width: 50%;
      max-width: 180px;
    }
  }

</style>
